<section class="container">
    <div class="login">
      {{bs.getResource('rbkey_PgNtFndLBL')}}
    </div>
</section>
